import { render, staticRenderFns } from "./BannerTop.vue?vue&type=template&id=7454185a&"
import script from "./BannerTop.vue?vue&type=script&lang=js&"
export * from "./BannerTop.vue?vue&type=script&lang=js&"
import style0 from "./BannerTop.vue?vue&type=style&index=0&id=7454185a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartCountdownAuto: require('/opt/build/repo/components/Cart/CountdownAuto.vue').default,CartCountdownAltAuto: require('/opt/build/repo/components/Cart/CountdownAltAuto.vue').default})
